import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { ArrowPaginationLeft, ArrowPaginationRight } from "../assets/icons/Icons";
import {useTranslation} from "react-i18next";

const Pagination = ({ pageCount }) => {
    const {t} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    // Get the current page from URL or default to 1
    const searchParams = new URLSearchParams(location.search);
    const currentPage = Number(searchParams.get('page')) || 1;

    const handlePageClick = (event) => {
        searchParams.set('page', event.selected + 1);
        navigate(`${location.pathname}?${searchParams.toString()}`);
    };

    return (
        pageCount > 0 && (
            <div className="pagination">
                <ReactPaginate
                    breakLabel="..."
                    nextLabel={<>{t("Next")} &nbsp;<ArrowPaginationRight /></>}
                    nextLinkClassName="btn btn-secondary btn-medium text-right"
                    previousLinkClassName="btn btn-secondary btn-medium"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    previousLabel={<><ArrowPaginationLeft />&nbsp; {t("Previous")}</>}
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />
            </div>
        )
    );
};

export default Pagination;
